'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkStatus = exports.json = exports.RxTargetingAPI = exports.RxMessagingAPI = exports.RxPagesAPI = exports.RxAnswersAPI = exports.RxIntegrationAPI = exports.RxBillingAPI = exports.RxEmailApi = exports.RxEnrichmentAPI = exports.RxAuthAPI = exports.RxDriftMetricsAPI = exports.RxKnowledgebaseAPI = exports.RxFileAPI = exports.RxReportAPI = exports.RxEventAPI = exports.RxGdprAPI = exports.RxInboxAPI = exports.RxConversationClientAPI = exports.RxLiveAPI = exports.RxConversationAPI = exports.RxKongCustomerAPI = exports.RxCustomerAPI = exports.RxAttachmentsAPI = exports.TargetingAPI = exports.MessagingAPI = exports.PagesAPI = exports.AnswersAPI = exports.IntegrationAPI = exports.BillingAPI = exports.EmailAPI = exports.ReportAPI = exports.EnrichmentAPI = exports.AuthAPI = exports.DriftMetricsAPI = exports.KnowledgebaseAPI = exports.DriftAPI = exports.FileAPI = exports.EventAPI = exports.InboxAPI = exports.ConversationClientAPI = exports.LiveAPI = exports.ConversationAPI = exports.GdprAPI = exports.KongCustomerAPI = exports.CustomerAPI = exports.AttachmentsAPI = exports.AccountsAPI = undefined;

var _utils = require('./utils');

Object.defineProperty(exports, 'json', {
  enumerable: true,
  get: function get() {
    return _utils.json;
  }
});
Object.defineProperty(exports, 'checkStatus', {
  enumerable: true,
  get: function get() {
    return _utils.checkStatus;
  }
});

var _client = require('./client');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Clients
var AccountsAPI = exports.AccountsAPI = (0, _client.api)(_constants2.default.ACCOUNTS_API);
var AttachmentsAPI = exports.AttachmentsAPI = (0, _client.api)(_constants2.default.ATTACHMENTS_API);
var CustomerAPI = exports.CustomerAPI = (0, _client.api)(_constants2.default.CUSTOMER_API);
var KongCustomerAPI = exports.KongCustomerAPI = (0, _client.api)(_constants2.default.KONG_CUSTOMER_API);
var GdprAPI = exports.GdprAPI = (0, _client.api)(_constants2.default.GDPR_API);
var ConversationAPI = exports.ConversationAPI = (0, _client.api)(_constants2.default.CONVERSATION_API);
var LiveAPI = exports.LiveAPI = (0, _client.api)(_constants2.default.LIVE_API);
var ConversationClientAPI = exports.ConversationClientAPI = (0, _client.api)(_constants2.default.CONVERSATION_CLIENT_API);
var InboxAPI = exports.InboxAPI = (0, _client.api)(_constants2.default.INBOX_API);
var EventAPI = exports.EventAPI = (0, _client.api)(_constants2.default.EVENT_API);
var FileAPI = exports.FileAPI = (0, _client.api)(_constants2.default.FILE_API, { file: true });
var DriftAPI = exports.DriftAPI = (0, _client.api)(_constants2.default.DRIFT_API);
var KnowledgebaseAPI = exports.KnowledgebaseAPI = (0, _client.api)(_constants2.default.KNOWLEDGEBASE_API);
var DriftMetricsAPI = exports.DriftMetricsAPI = (0, _client.api)(_constants2.default.DRIFT_METRICS_API);
var AuthAPI = exports.AuthAPI = (0, _client.api)(_constants2.default.AUTH_API);
var EnrichmentAPI = exports.EnrichmentAPI = (0, _client.api)(_constants2.default.ENRICHMENT_API);
var ReportAPI = exports.ReportAPI = (0, _client.api)(_constants2.default.REPORT_API);
var EmailAPI = exports.EmailAPI = (0, _client.api)(_constants2.default.EMAIL_API);
var BillingAPI = exports.BillingAPI = (0, _client.api)(_constants2.default.BILLING_API);
var IntegrationAPI = exports.IntegrationAPI = (0, _client.api)(_constants2.default.INTEGRATION_API);
var AnswersAPI = exports.AnswersAPI = (0, _client.api)(_constants2.default.ANSWERS_API);
var PagesAPI = exports.PagesAPI = (0, _client.api)(_constants2.default.PAGES_API);
var MessagingAPI = exports.MessagingAPI = (0, _client.api)(_constants2.default.MESSAGING_API);
var TargetingAPI = exports.TargetingAPI = (0, _client.api)(_constants2.default.TARGETING_API);

// Observable Clients
var RxAttachmentsAPI = exports.RxAttachmentsAPI = (0, _client.rxApi)(_constants2.default.ATTACHMENTS_API);
var RxCustomerAPI = exports.RxCustomerAPI = (0, _client.rxApi)(_constants2.default.CUSTOMER_API);
var RxKongCustomerAPI = exports.RxKongCustomerAPI = (0, _client.rxApi)(_constants2.default.KONG_CUSTOMER_API);
var RxConversationAPI = exports.RxConversationAPI = (0, _client.rxApi)(_constants2.default.CONVERSATION_API);
var RxLiveAPI = exports.RxLiveAPI = (0, _client.rxApi)(_constants2.default.LIVE_API);
var RxConversationClientAPI = exports.RxConversationClientAPI = (0, _client.rxApi)(_constants2.default.CONVERSATION_CLIENT_API);
var RxInboxAPI = exports.RxInboxAPI = (0, _client.rxApi)(_constants2.default.INBOX_API);
var RxGdprAPI = exports.RxGdprAPI = (0, _client.rxApi)(_constants2.default.GDPR_API);
var RxEventAPI = exports.RxEventAPI = (0, _client.rxApi)(_constants2.default.EVENT_API);
var RxReportAPI = exports.RxReportAPI = (0, _client.rxApi)(_constants2.default.REPORT_API);
var RxFileAPI = exports.RxFileAPI = (0, _client.rxApi)(_constants2.default.FILE_API, { file: true });
var RxKnowledgebaseAPI = exports.RxKnowledgebaseAPI = (0, _client.rxApi)(_constants2.default.KNOWLEDGEBASE_API);
var RxDriftMetricsAPI = exports.RxDriftMetricsAPI = (0, _client.rxApi)(_constants2.default.DRIFT_METRICS_API);
var RxAuthAPI = exports.RxAuthAPI = (0, _client.rxApi)(_constants2.default.AUTH_API);
var RxEnrichmentAPI = exports.RxEnrichmentAPI = (0, _client.rxApi)(_constants2.default.ENRICHMENT_API);
var RxEmailApi = exports.RxEmailApi = (0, _client.rxApi)(_constants2.default.EMAIL_API);
var RxBillingAPI = exports.RxBillingAPI = (0, _client.rxApi)(_constants2.default.BILLING_API);
var RxIntegrationAPI = exports.RxIntegrationAPI = (0, _client.rxApi)(_constants2.default.INTEGRATION_API);
var RxAnswersAPI = exports.RxAnswersAPI = (0, _client.rxApi)(_constants2.default.ANSWERS_API);
var RxPagesAPI = exports.RxPagesAPI = (0, _client.rxApi)(_constants2.default.PAGES_API);
var RxMessagingAPI = exports.RxMessagingAPI = (0, _client.rxApi)(_constants2.default.MESSAGING_API);
var RxTargetingAPI = exports.RxTargetingAPI = (0, _client.rxApi)(_constants2.default.TARGETING_API);

// Utils


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drifthq/dapper/lib/index.js
// module id = 89
// module chunks = 0